import axios from '@/axios'
import * as types from '../mutation-types'

export default {
    namespaced: true,

    state: {
        evaluations: []
    },

    actions: {
        fetchAll({ commit }, { employeeIds, sectionId, jobDescriptionId, evaluationType, fromDate, toDate, page, perPage }) {
            return axios.get('/evaluation/employees', {
                employeeIds, sectionId, jobDescriptionId, evaluationType, fromDate, toDate, page, perPage, whereNonDeleted: true
            }).then(({ data }) => {
				commit(types.STORE_EVALUATIONS, data);
				return data;
			});
        },

        fetchById(_, { id }) {
            return axios.get(`/evaluation/${id}`)
        },

        fetchByEmployeeId(_, { employeeId }) {
            return axios.get(`/evaluation/employee/${employeeId}`)
        },

        createEmployeeEvaluation(_, { employeeId, jobDescriptionId, sectionId, date, fromDate, toDate, note, evaluationRecommendations, evaluationData, employeeEvaluationData }) {
            return axios.post('', { employeeId, jobDescriptionId, sectionId, date, fromDate, toDate, note, evaluationRecommendations, evaluationData, employeeEvaluationData });
        }
    },

    mutations: {
		[types.STORE_EVALUATIONS](state, evaluations) {
			state.evaluations = evaluations;
		}
    },

    getters: {
		getEvaluationById: state => id => state.evaluations.find(c => c.id === id)
    }
}